// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  API_URL: '${API_URL}',
  APP_KEY: '${APP_KEY}',
  APP_SECRET: '${APP_SECRET}',
  API_CURP_URL: '${API_CURP_URL}',
  API_REGISTRO_URL: '${API_REGISTRO_URL}',
  portalSb: '${SB_PORTAL}',
  portalCms: '${CMS_PORTAL}',
  VENTANILLA_URL: '${VENTANILLA_URL}',
  VENTANILLA_API_URL: '${VENTANILLA_API_URL}',
  VENTANILLA_APP_KEY:'${VENTANILLA_APP_KEY}',
  VENTANILLA_APP_SECRET:'${VENTANILLA_APP_SECRET}',
  
  // VENTANILLA_URL: "https://sb-vdigital-app.apps.sbc-dev.segurosbanorte.com/",    
  // VENTANILLA_API_URL: "https://sb-sales-channels.apps.sbc-dev.segurosbanorte.com",    
  // VENTANILLA_APP_KEY: "f99317ce-e9ff-45f8-8d40-88df06a8d050",    
  // VENTANILLA_APP_SECRET: "ojhN7RtB+TixTxPLy++DL5Zg+ub6bOigQHP9k6hBmZdFKRqKG72zAuvlvceyM8sH",
  // API_URL: 'https://sb-sales-channels.apps.sbc-qas.segurosbanorte.com',
  // APP_KEY: 'f99317ce-e9ff-45f8-8d40-88df06a8d050',
  // APP_SECRET: 'ojhN7RtB+TixTxPLy++DL5Zg+ub6bOigQHP9k6hBmZdFKRqKG72zAuvlvceyM8sH',
  // portalSb: 'https://portal.qas.segurosbanorte.com',
  // portalCms: 'https://portal.qas.segurosbanorte.com',
  // API_CURP_URL: 'https://sb-sales-channels.apps.sbc-dev.segurosbanorte.com',
  // API_REGISTRO_URL: 'https://sb-sales-channels.apps.sbc-dev.segurosbanorte.com',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */

